var map = {
	"./ACCOUNTING.svg": "c9b2",
	"./ACTIVE_SESSIONS.svg": "ae07",
	"./ADDRESS.svg": "3801",
	"./ASC_SORT.svg": "f2b2",
	"./ATTACHMENT.svg": "bb1f",
	"./ATTRIBUTES.svg": "7a53",
	"./BACKUP.svg": "7bcf",
	"./BARCODE.svg": "bed0",
	"./BOX.svg": "2068",
	"./BUY.svg": "2cfb",
	"./CALENDER.svg": "0c7b",
	"./CHECK.svg": "cacd",
	"./CHEVRON_BOTTOM.svg": "c723",
	"./CHEVRON_LEFT.svg": "84e2",
	"./CHEVRON_RIGHT.svg": "4a59b",
	"./CHEVRON_TOP.svg": "2661",
	"./CLOCK.svg": "d827",
	"./COPY.svg": "a19e",
	"./CREDIT_CARD.svg": "2a7c",
	"./DESC_SORT.svg": "7fa0",
	"./DISCOUNT.svg": "766a",
	"./DOLLAR_SIGN.svg": "54c8",
	"./DOWNLOAD.svg": "d046",
	"./EDIT.svg": "6ffc",
	"./EQUAL.svg": "ffb4",
	"./EQULIZER.svg": "3823",
	"./EVENT.svg": "96a4",
	"./EXPORT.svg": "8590",
	"./EYE.svg": "c972",
	"./FILTER.svg": "fb64",
	"./FINANCIAL_YEAR.svg": "a837",
	"./HIDE.svg": "e52e",
	"./HOME.svg": "fe6c",
	"./IMPORT.svg": "867f",
	"./INVENTORY.svg": "6d87",
	"./INVOICE.svg": "6cd0",
	"./LANG_SETTING.svg": "cbf2",
	"./LAPTOP.svg": "5245",
	"./LAST_ACTIVITIES.svg": "1ccb",
	"./LIST.svg": "afb6",
	"./LOCK.svg": "6c5c",
	"./LOGOUT.svg": "5aa5",
	"./LTE.svg": "6ce35",
	"./MENU.svg": "cbe2",
	"./MESSAGE.svg": "c181",
	"./MIGRATION.svg": "c16c",
	"./MINUS.svg": "a0e5",
	"./MOBILE.svg": "d9db",
	"./MONEY.svg": "1184",
	"./MOVE.svg": "92d00",
	"./NOT_EQUAL.svg": "8272",
	"./OPEN_NEW_TAB.svg": "68ea",
	"./PASTE.svg": "dd54",
	"./PAY.svg": "f552",
	"./PAYMENT.svg": "8467",
	"./PDF.svg": "51fa",
	"./PERCENT.svg": "06d7",
	"./PHONE.svg": "8f63",
	"./PHONE_CALL.svg": "84fb",
	"./PIE_CHART.svg": "ab10",
	"./PLUS.svg": "f23f",
	"./POST.svg": "f792",
	"./PRINT.svg": "718c",
	"./RECEIVE.svg": "7a86",
	"./RECEIVE_MONEY.svg": "e097",
	"./RECYCLE_BIN.svg": "d39d",
	"./REFRESH.svg": "9c3d",
	"./REFRESH_STATUS.svg": "3616",
	"./RETURN_SALE.svg": "6776",
	"./SALE.svg": "d829",
	"./SAVE.svg": "1f31",
	"./SAVE_CLOSE.svg": "27cb",
	"./SAVE_NEW.svg": "b856",
	"./SAVE_PAY.svg": "24de",
	"./SEARCH.svg": "e70b",
	"./SEND.svg": "0e6b7",
	"./SEND_MESSAGE.svg": "249e",
	"./SERVICE.svg": "ca6d2",
	"./SETTING.svg": "84ff",
	"./SHIELD.svg": "0b7a",
	"./SHIPPING.svg": "22f5",
	"./SHOPPING_BAG.svg": "9c7a",
	"./SLIDERS.svg": "5a4d",
	"./SUPPORT.svg": "7a9a",
	"./TIMES-CIRCLE.svg": "be3d",
	"./TIMES.svg": "8208",
	"./TRASH.svg": "64034",
	"./TREASURY.svg": "776c",
	"./TURNOVER.svg": "de52",
	"./UPLOAD.svg": "75ff",
	"./USER.svg": "38b6",
	"./USERAL.svg": "3381",
	"./USERS.svg": "7a8f",
	"./USERS_SETTING.svg": "34a07",
	"./VARIANT_BOX.svg": "be99",
	"./VAT.svg": "82ef",
	"./WAREHOUSING.svg": "3b22",
	"./WHATSAPP.svg": "0fe5",
	"./WOOCOMMERCE_LARGE.svg": "6fc7",
	"./WOOCOMMERCE_SMALL.svg": "6347",
	"./WOOCOMMERCE_TEXT.svg": "9d5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";